import { render, staticRenderFns } from "./drawerPick.vue?vue&type=template&id=2f6e3884&scoped=true&"
import script from "./drawerPick.vue?vue&type=script&lang=ts&"
export * from "./drawerPick.vue?vue&type=script&lang=ts&"
import style0 from "./drawerPick.vue?vue&type=style&index=0&id=2f6e3884&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e3884",
  null
  
)

export default component.exports